export default function ResumeDivider() {
  return (
    <>
      <div style={{ padding: '0.1em' }}></div>
      <hr className="minor" />
      <div style={{ padding: '0.4em' }}></div>
    </>
  );
}
